import React, { useState, useEffect } from "react";
import MobileFooter from "./MobileFooter";
import { Link } from "react-router-dom";

import { menuList } from "@/data/menu";
import { useLocation } from "react-router-dom";

export default function Menu({ allClasses, headerPosition }) {
  const [menuItem, setMenuItem] = useState("");
  const { pathname } = useLocation();

  useEffect(() => {
    menuList.forEach((elm) => {
      elm?.links?.forEach((elm2) => {
        if (elm2.href?.split("/")[1] == pathname.split("/")[1]) {
          setMenuItem(elm.title);
        } else {
          elm2?.links?.map((elm3) => {
            if (elm3.href?.split("/")[1] == pathname.split("/")[1]) {
              setMenuItem(elm.title);
            }
          });
        }
      });
    });
  }, []);

  return (
    <div
      className={`header-menu js-mobile-menu-toggle ${
        headerPosition ? headerPosition : ""
      }`}
    >
      <div className="header-menu__content">
        <div className="mobile-bg js-mobile-bg"></div>

        <div className="d-none xl:d-flex items-center px-20 py-20 border-bottom-light">
          <Link to="/login" className="text-dark-1">
            Log in
          </Link>
        </div>

        <div className="menu js-navList">
          <ul className={`${allClasses ? allClasses : ""}`}>
            {menuList.map((menuListItem, i) => (
              <li key={i} className="menu-item-has-children">
                <Link
                  data-barba
                  to={menuListItem.href}
                  className={menuItem == "Home" ? "activeMenu" : ""}
                >
                  {menuListItem.title}
                 {menuListItem.links && <i className="icon-chevron-right text-13 ml-10"></i>}
                </Link>

                {menuListItem.links && (
                  <ul className="subnav">
                    <li className="menu__backButton js-nav-list-back">
                      <Link to="about-us" className="text-dark-1">
                        <i className="icon-chevron-left text-13 mr-10"></i>{" "}
                        {menuListItem.title}
                      </Link>
                    </li>

                    {menuListItem.links.map((elm, i) => (
                      <li
                        key={i}
                        className={
                          pathname?.split("/")[1] == elm.href?.split("/")[1]
                            ? "activeMenu"
                            : "inActiveMenu"
                        }
                      >
                        <Link to={elm.href}>{elm.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* mobile footer start */}
        <MobileFooter />
        {/* mobile footer end */}
      </div>

      <div
        className="header-menu-close"
        data-el-toggle=".js-mobile-menu-toggle"
      >
        <div className="size-40 d-flex items-center justify-center rounded-full bg-white">
          <div className="icon-close text-dark-1 text-16"></div>
        </div>
      </div>

      <div className="header-menu-bg"></div>
    </div>
  );
}
